var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather-container"},[_c('div',{staticClass:"tab"},[_c('router-link',{staticClass:"tab__item",attrs:{"tag":"a","to":"/tempo/mapa-windy"}},[_vm._v(" Mapa ")])],1),_c('div',{staticClass:"weather-container__content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }